// 'use client';

import LayoutHeader from '../../../@layouts/components/horizontal/Header';
// Component Imports
import Navbar from '../../../@layouts/components/horizontal/Navbar';

// Hook Imports
import useHorizontalNav from '../../../@menu/hooks/useHorizontalNav';
import { HorizontalNavbarContent } from './NavbarContent';
import { HorizontalNavigation } from './Navigation';

export const HorizontalHeader = () => {
  // Hooks
  const { isBreakpointReached } = useHorizontalNav();

  return (
    <>
      <LayoutHeader>
        <Navbar>
          <HorizontalNavbarContent />
        </Navbar>
        {!isBreakpointReached && <HorizontalNavigation />}
      </LayoutHeader>
      {isBreakpointReached && <HorizontalNavigation />}
    </>
  );
};
